import './myfont.font';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { VueMasonryPlugin } from 'vue-masonry';
// import FastClick from 'fastclick';
import { eventBus } from './services/EventBus';
import memoryStore from './stores/MemoryStore';
// import cookieService from './services/Cookies.service';
import 'normalize.css';
import gApiWrapper from './services/GapiWrapper.service';
import userService from './services/User.service';
// import './assets/style.css';
import './registerServiceWorker';

// FastClick.attach(document.body);
// let counter = 0;
// function hideSplashPlage() {
//   counter++;
//   if (navigator.splashscreen || counter === 5) {
//     try {
//       navigator.splashscreen.hide();
//     } catch (error) { }
//   } else {
//     setTimeout(hideSplashPlage, 1000);
//   }
// }
// console.log('DO LOGOUT');

// cookieService.deleteCookie('user');
// userService.softLogout();
// console.log('isAuthenticated', userService.isAuthenticated());

gApiWrapper.init().catch(() => { });
Vue.use(VueMasonryPlugin);
// Vue.use(VueHammer);

// console.log('set timeout hideSplashPage', new Date().getTime());
// setTimeout(hideSplashPlage, 5000);
router.beforeEach((to, from, next) => {
  eventBus.$emit('hideMenuProfile');
  eventBus.$emit('hideNotifications');
  if (to.name !== ('login') && !userService.isAuthenticated()) {
    next('/login');
  } else if (to.path === '/edit-image' && memoryStore.editableImage) {
    next();
  } else if (to.path === '/edit-image' && !memoryStore.editableImage) {
    next('/');
  } else {
    if (memoryStore.editableImage) {
      delete memoryStore.editableImage;
    }
    next();
  }
});

Vue.config.productionTip = false;
new Vue({
  router,
  render: function (h) { return h(App); }
}).$mount('#app');
